var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35 4.17a.75.75 0 01.817.163l5.727 5.727a.75.75 0 01-.53 1.28H8.637a.75.75 0 01-.75-.75V4.864a.75.75 0 01.463-.693zm1.037 2.504v3.167h3.166L9.387 6.674zM15.986 1.307a.75.75 0 01.818.163l5.727 5.727a.75.75 0 01-.53 1.28h-5.728a.75.75 0 01-.75-.75V2a.75.75 0 01.463-.693zm1.037 2.504v3.166h3.167l-3.167-3.166z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.25 5.818c0-1.035.863-1.705 1.705-1.705h6.681a.75.75 0 110 1.5H1.955c-.044 0-.1.02-.145.061a.184.184 0 00-.06.144v16.227c0 .066.023.11.06.144.044.041.101.06.145.06h11.454c.043 0 .1-.019.145-.06a.184.184 0 00.06-.144V10.591a.75.75 0 111.5 0v11.454c0 1.035-.863 1.705-1.705 1.705H1.955c-.842 0-1.705-.67-1.705-1.705V5.818zM22 6.977a.75.75 0 01.75.75V19.18c0 1.035-.863 1.705-1.705 1.705h-3.818a.75.75 0 110-1.5h3.818c.043 0 .1-.02.144-.061a.184.184 0 00.06-.144V7.727a.75.75 0 01.75-.75zM7.887 2a.75.75 0 01.75-.75h7.636a.75.75 0 010 1.5H8.637a.75.75 0 01-.75-.75z",
    fill: "currentColor"
  })));
}

export default SvgCopy;